import FrontCardRoyal from '@assets/images/card/RoyalFront.svg';
import FrontCardGlamour from '@assets/images/card/GlamourFront.svg';
import FrontCardElite from '@assets/images/card/EliteFront.svg';
import FrontCardLabel from '@assets/images/card/LabelFront.svg';
import FrontCardJewellery from '@assets/images/card/398cff9a3e19941a20d059d3553058c7.png';
import FrontCardBillionaire from '@assets/images/card/Billionaire.front.svg';
import FrontCardWellness from '@assets/images/card/Wellness.front.svg';
import FrontCardHabtoor from '@assets/images/card/HabtoorFront.svg';
import FrontCardHP from '@assets/images/card/HPFront.svg';
import frontCardSolfeggioImg from '@assets/images/card/Bellatrix.front.round.svg?url';

import BackCardRoyal from '@assets/images/card/70e8ce00a21fbab7d3c3228802b73cd0.png';
import BackCardGlamour from '@assets/images/card/GlamourBack.svg';
import BackCardElite from '@assets/images/card/0412ea831a422c3e6318fdf13b0ef910.png';
import BackCardBillionaire from '@assets/images/card/Billionaire.back.svg';
import BackCardWellness from '@assets/images/card/Wellness.back.svg';
import BackCardHabtoor from '@assets/images/card/HabtoorBack.svg';
import BackCardHP from '@assets/images/card/HPBack.svg';
import backCardSolfeggioImg from '@assets/images/card/Bellatrix.back.svg?url';

export class CardImageUtils {
  static getCardImages = (product: string, cardImgRef?: React.Ref<SVGSVGElement>) => {
    switch (product) {
      case 'Royal':
        return {
          front: <FrontCardRoyal ref={cardImgRef} className='block h-auto max-w-full' />,
          back: <img className='block h-auto max-w-full' src={BackCardRoyal} alt='Royal Card Back' />,
        };
      case 'Glamour':
        return {
          front: <FrontCardGlamour className='block h-auto max-w-full' />,
          back: <BackCardGlamour className='block h-auto max-w-full' />,
        };
      case 'Elite':
        return {
          front: <FrontCardElite className='block h-auto max-w-full' />,
          back: <img className='block h-auto max-w-full' src={BackCardElite} alt='Elite Card Back' />,
        };
      case 'Label':
        return {
          front: <FrontCardLabel className='block h-auto max-w-full' />,
          back: <img className='block h-auto max-w-full' src={BackCardElite} alt='Label Card Back' />,
        };
      case 'Jewellery':
        return {
          front: <img className='block h-auto max-w-full' src={FrontCardJewellery} alt='Jewellery Card Front' />,
          back: <img className='block h-auto max-w-full' src={BackCardElite} alt='Jewellery Card Back' />,
        };
      case 'Billionaire':
        return {
          front: <FrontCardBillionaire className='block h-auto max-w-full' />,
          back: <BackCardBillionaire className='block h-auto max-w-full' />,
        };
      case 'Wellness':
        return {
          front: <FrontCardWellness className='block h-auto max-w-full' />,
          back: <BackCardWellness className='block h-auto max-w-full' />,
        };
      case 'Habtoor':
        return {
          front: <FrontCardHabtoor className='block h-auto max-w-full' />,
          back: <BackCardHabtoor className='block h-auto max-w-full' />,
        };
      case 'HP':
        return {
          front: <FrontCardHP className='block h-auto max-w-full' />,
          back: <BackCardHP className='block h-auto max-w-full' />,
        };
      case 'Solfeggio':
        return {
          front: <img className='block h-auto max-w-full' src={frontCardSolfeggioImg} alt='Solfeggio Card Front' />,
          back: <img className='block h-auto max-w-full' src={backCardSolfeggioImg} alt='Solfeggio Card Back' />,
        };
      default:
        return { front: null, back: null };
    }
  };
}
